'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RatingCard = require('./components/RatingCard.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RatingCard).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/card/rating-card/lib/index.js
// module id = 990
// module chunks = 9